var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBuyNowIcon = function SvgBuyNowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "button-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.125,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M16.433 13.826H9.018a2.988 2.988 0 0 1-2.867-2.171L4.472 5.721a.555.555 0 0 1 .142-.545l.872-.87a3.466 3.466 0 0 1 2.437-1.01h11.262a1.935 1.935 0 0 1 1.857 2.489l-1.762 5.911a2.956 2.956 0 0 1-2.851 2.131Zm-10.8-8.091 1.59 5.62a1.87 1.87 0 0 0 1.795 1.359h7.413a1.862 1.862 0 0 0 1.79-1.332l1.759-5.904a.822.822 0 0 0-.79-1.061H7.93a2.342 2.342 0 0 0-1.652.685Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M5.011 6.127a.555.555 0 0 1-.534-.4l-1.016-3.6A1.4 1.4 0 0 0 2.124 1.12H.556a.556.556 0 1 1 0-1.112h1.566a2.515 2.515 0 0 1 2.406 1.815l1.019 3.605a.554.554 0 0 1-.385.685.519.519 0 0 1-.151.022Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M18.544 16.889H7.21a2.086 2.086 0 0 1 0-4.172h2.658a.556.556 0 1 1 0 1.112H7.21a.974.974 0 1 0 0 1.948h11.334a.556.556 0 1 1 0 1.112Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M18.548 20.001a2.113 2.113 0 1 1 2.113-2.113 2.115 2.115 0 0 1-2.113 2.113Zm0-3.111a1 1 0 1 0 1 1 1 1 0 0 0-1-1.001Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M9.007 20.001a2.113 2.113 0 1 1 2.113-2.113 2.115 2.115 0 0 1-2.113 2.113Zm0-3.111a1 1 0 1 0 1 1 1 1 0 0 0-1-1.001Z"
  })));
};
export default SvgBuyNowIcon;